import React from "react";
import { Link } from "react-router-dom";
import { FaUsers, FaListAlt, FaRocket, FaBullhorn, FaChevronRight } from "react-icons/fa";
import useAuthorization from "../../../hooks/useAuthorization";
import { UserRole } from "../../../enums/UserRole";
import "./admin-dashboard.css";

const TILES = [
  {
    id:          "A1",
    title:       "Users",
    desc:        "Manage seller accounts, verify identities and control access",
    icon:        <FaUsers size={26} />,
    navigateTo:  "/admin/users?page=1&userType=sellers",
  },
  {
    id:          "A2",
    title:       "Ads",
    desc:        "Review new listings and approve or reject ad updates",
    icon:        <FaListAlt size={26} />,
    navigateTo:  "/admin/ads?page=1&adType=newClassifieds",
  },
  {
    id:          "A3",
    title:       "Boost Requests",
    desc:        "Process premium placement requests from sellers",
    icon:        <FaRocket size={26} />,
    navigateTo:  "/admin/boost-requests?page=1",
  },
  {
    id:          "A4",
    title:       "Third Party Ads",
    desc:        "Manage banner ads and promotional placements",
    icon:        <FaBullhorn size={26} />,
    navigateTo:  "/admin/third-party-ads",
  },
];

function AdminDashboardPage() {
  useAuthorization([UserRole.ADMIN, UserRole.ROOT]);

  return (
    <div style={{ minHeight: "calc(100vh - 68px)", background: "#f8fafc", padding: "2.5rem 0 3.5rem" }}>
      <div className="container">

        {/* Header */}
        <div style={{ marginBottom: "2rem" }}>
          <h2 className="admin-page-title">Admin Dashboard</h2>
          <p className="admin-page-subtitle">Manage listings, users, and promotions</p>
        </div>

        {/* 2×2 tile grid */}
        <div className="row g-4">
          {TILES.map((tile) => (
            <div key={tile.id} className="col-sm-12 col-md-6">
              <Link to={tile.navigateTo} className="admin-tile">
                <div className="admin-tile__icon-wrap">
                  {tile.icon}
                </div>
                <div className="admin-tile__body">
                  <p className="admin-tile__title">{tile.title}</p>
                  <p className="admin-tile__desc">{tile.desc}</p>
                </div>
                <FaChevronRight size={16} className="admin-tile__arrow" />
              </Link>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default AdminDashboardPage;
